import { defineStore } from 'pinia';

import * as state from './announcement.state';
import * as getters from './announcement.getters';
import * as actions from './announcement.actions';

export const useAnnouncementStore = defineStore('announcement', () => ({
  ...state,
  ...getters,
  ...actions
}));
